import { render, staticRenderFns } from "./FormInputTextarea.vue?vue&type=template&id=b61a3e1e&"
import script from "./FormInputTextarea.vue?vue&type=script&lang=js&"
export * from "./FormInputTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b61a3e1e')) {
      api.createRecord('b61a3e1e', component.options)
    } else {
      api.reload('b61a3e1e', component.options)
    }
    module.hot.accept("./FormInputTextarea.vue?vue&type=template&id=b61a3e1e&", function () {
      api.rerender('b61a3e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/FormInputTextarea.vue"
export default component.exports